<template>
    <div>
        <pb-spinner v-if="busy"/>
        <div v-if="!busy">
            <slot></slot>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'pb-body-base',
        props: {
            busy: {
                type: Boolean
            }
        }
    }
</script>